import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BaseService } from '@services/base-service.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtilitiesService } from '@services/utilities.service';

@Component({
  selector: ' app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent implements OnInit {
  @ViewChild('imageUpload') imageUpload: ElementRef;

  @Output() urlOutput: any = new EventEmitter();
  @Output() loadingState = new EventEmitter();
  @Input() type: string | null;
  @Input() style: string = 'default';
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() idx: string | number;
  @Input() showLabel: boolean = true;

  @Input() data?: { url: string };
  @Input() enableDelete: boolean | undefined = true;
  @Input() maxUploadSize: number = 3; // Mb
  @Input() isDisabled: undefined | boolean = false;

  hasError = false;
  errorMessage: string = '';
  ctaLabelFile = 'Pilih File';

  ALLOWED_EXTENSIONS = ['image/jpg', 'image/jpeg', 'image/png'];

  constructor(private baseService: BaseService, private utils: UtilitiesService) {
    this.fileUrl$ = this.fileUrl.asObservable();
    this.isLoading$ = this.isLoading.asObservable();
  }

  ngOnInit(): void {
    if (this.data) {
      this.fileUrl.next(this.data.url);
    }
  }

  public files: any;
  public fileUrl: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

  isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  STRING_CONSTANTS = STRING_CONSTANTS;
  fileUrl$: Observable<any>;
  isLoading$: Observable<boolean>;

  onFileChange(e: any) {
    // this.onRemoveFile();
    this.onFileChangeFile(e.target.files);
  }

  onFileChangeFile(e: File[]) {
    const file = e[0];

    if (!file) {
      return;
    }

    if (!this.isAllowedExtension(file)) {
      return this.setError('INVALID_FILE_EXTENSION');
    }

    const formData = new FormData();
    const fileSizeMb = this.fileSizeToMb(file.size);
    this.setLoading(true);

    if (fileSizeMb > this.maxUploadSize) {
      return this.setError('MAX_FILE_SIZE');
    }

    formData.append('file', file, file?.name);
    formData.append('category', 'IMAGE');

    this.handleUpload(formData);
  }

  onRemoveFile() {
    this.fileUrl.next('');
    this.urlOutput.emit(this.fileUrl);
    this.hasError = false;
    this.ctaLabelFile = 'Pilih File';
  }

  handleUpload(formData: FormData) {
    this.baseService.uploadData<any>(formData, { disableModalPopupError: true }).subscribe((res) => {
      if (!res) return;

      if (res.success) {
        this.fileUrl.next(res.data.url);
        this.urlOutput.emit(this.fileUrl);
        this.ctaLabelFile = 'Ganti File';
      }

      if (res.errors) {
        this.onRemoveFile();
        this.handleSwitchErrors(res.errors);
      }

      this.setLoading(false);
    });
  }

  handleSwitchErrors(res: [{ code: number; title: string; message: string }]) {
    switch (res[0].code) {
      case 0:
        this.setError('ERR_INTERNET_DISCONNECTED');
        break;
      default:
        this.setError('ERR_FAILED');
        break;
    }
  }

  fileSizeToMb(size: number) {
    return +(size / 1024 ** 2).toFixed(2);
  }

  setLoading(state: boolean) {
    this.isLoading.next(state);
    this.loadingState.emit(state);
  }

  setError(type: string) {
    if (!type) {
      return;
    }

    this.hasError = true;
    const errMsg = 'File yang diupload ';
    const errUploadFailed = 'File gagal diupload';

    switch (type) {
      case 'MAX_FILE_SIZE':
        this.errorMessage = `${errMsg} lebih dari ${this.maxUploadSize}Mb`;
        this.ctaLabelFile = 'Ganti File';
        break;

      case 'INVALID_FILE_EXTENSION':
        this.errorMessage = `Format ${errMsg} tidak didukung.`;
        this.errorMessage += `<br>Format file yang didukung: ${this.utils.arrayStringJoin(this.ALLOWED_EXTENSIONS, null, ',', true)}`;
        this.ctaLabelFile = 'Ganti File';
        break;

      case 'ERR_INTERNET_DISCONNECTED':
        this.errorMessage = `${errUploadFailed} karena koneksi internet.`;
        break;

      case 'ERR_FAILED':
        this.errorMessage = `${errUploadFailed} karena kesalahan sistem.`;
        break;
    }

    this.urlOutput.emit(new BehaviorSubject('ERROR'));
    this.setLoading(false);
  }

  isAllowedExtension(file: File) {
    return this.ALLOWED_EXTENSIONS.includes(file.type);
  }

  greaterThanZero(val = this.idx) {
    return Number(val) > 0;
  }
}

// todo: refactor
// to use documentUpload component
